var map = {
	"./general/DocsIcon--bluecheckmark.svg": 1672,
	"./general/DocsIcon--country.svg": 1673,
	"./general/DocsIcon--github.svg": 1674,
	"./general/DocsIcon--guide.svg": 1675,
	"./general/DocsIcon--list.svg": 1676,
	"./general/DocsIcon--locale.svg": 1677,
	"./general/DocsIcon--thumbsdown.svg": 1678,
	"./general/DocsIcon--thumbsup.svg": 1679,
	"./general/DocsIcon--video.svg": 1680,
	"./nav/DocsIcon--account.svg": 1681,
	"./nav/DocsIcon--business.svg": 1682,
	"./nav/DocsIcon--developertools.svg": 1683,
	"./nav/DocsIcon--financialservices.svg": 1684,
	"./nav/DocsIcon--home.svg": 1685,
	"./nav/DocsIcon--mobilenav.svg": 1686,
	"./nav/DocsIcon--payments.svg": 1687,
	"./nav/DocsIcon--reference.svg": 1688,
	"./nav/DocsIcon--security.svg": 1689,
	"./product/DocsIcon--account.svg": 1690,
	"./product/DocsIcon--atlas.svg": 1691,
	"./product/DocsIcon--capital.svg": 1692,
	"./product/DocsIcon--checkout.svg": 1693,
	"./product/DocsIcon--climate.svg": 1694,
	"./product/DocsIcon--connect.svg": 1695,
	"./product/DocsIcon--corporatecard.svg": 1696,
	"./product/DocsIcon--dashboard.svg": 1697,
	"./product/DocsIcon--developertools.svg": 1698,
	"./product/DocsIcon--elements.svg": 1699,
	"./product/DocsIcon--gateddocs.svg": 1700,
	"./product/DocsIcon--identity.svg": 1701,
	"./product/DocsIcon--implementationguides.svg": 1702,
	"./product/DocsIcon--invoicing.svg": 1703,
	"./product/DocsIcon--issuing.svg": 1704,
	"./product/DocsIcon--partners.svg": 1705,
	"./product/DocsIcon--payments.svg": 1706,
	"./product/DocsIcon--radar.svg": 1707,
	"./product/DocsIcon--reporting.svg": 1708,
	"./product/DocsIcon--sigma.svg": 1709,
	"./product/DocsIcon--styleguide.svg": 1710,
	"./product/DocsIcon--tax.svg": 1711,
	"./product/DocsIcon--terminal.svg": 1712,
	"./product/DocsIcon--treasury.svg": 1713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1671;